export default __webpack_public_path__ + "static/media/NOT_TERMINAL_ICON_BLACK.2d7da193.svg";